import { Input } from '@components/inputs';
import styled from 'styled-components';

export const StyledInput = styled(Input)`
  padding: var(--spacing-8) var(--spacing-16);
`;
